<template>
    <div id="products-page" v-if="loged">
        <div class="page-header">
            <div class="user-info">
                <img class="v-m" :src="avatar" />
                <span class="v-m fb fs-0-8 segoe username">{{ username }}</span>
                <div class="user-id-cont">
                    <div class="user-id">
                        <span class="v-m fb fs-1 segpe userID">ID:{{ userID }}</span>
                        <img class="v-m btn" :src="_global.assetsRoot + '/tutorial_button.png'"
                            @click="showUserIDTutorialPopup" />
                    </div>
                    <div class="user-id-tip">
                        <span class="fs-12px segpe">{{ $t("message.userIDTip") }}</span>
                    </div>
                </div>
            </div>
            <div class="user-coins t-c v-m">
                <div class="coins v-m t-l">
                    <img ref="coinsIcon" class="coins-icon" :src="_global.assetsRoot + '/balance_coins_icon.png'" />
                    <span class="fs-1 segoe v-m">{{ airdropCoins || coins }}</span>
                </div>
            </div>
            <div class="user-dinero t-c v-m">
                <div class="dineros v-m t-l">
                    <img ref="chipsIcon" class="dinero-icon" :src="_global.assetsRoot + '/balance_dinero_icon.png'" />
                    <span class="fs-1 segoe v-m">{{ bonusChips || chips }}</span>
                </div>
            </div>
            <div class="logout t-r">
                <div class="btn logout-btn t-c v-m" @click.stop="showLogoutTip">
                    <img class="v-m" :src="_global.assetsRoot + '/logout_icon.png'" />
                    <span class="fs-0-8 fb v-m segoe">{{ $t("message.logout") }}</span>
                </div>
            </div>
        </div>
        <div class="page-content">
            <div class="content">
                <div class="banners" v-if="products && products.banners && products.banners.length > 0">
                    <swiper :options="swiperOptions" ref="swiperObj">
                        <swiper-slide v-for="(banner, i) in products.banners" :key="i">
                            <img :src="banner.src" />
                        </swiper-slide>
                    </swiper>
                </div>
                <div class="title t-c v-m" v-if="products.bundles.length > 0">
                    <img class="arrow reverse v-m" :src="_global.assetsRoot + '/pic_title.png'" />
                    <img class="title-icon v-m promition"
                        :src="_global.assetsRoot + `/promotion_${_i18n.locale}.png`" />
                    <img class="arrow v-m" :src="_global.assetsRoot + '/pic_title.png'" />
                </div>
                <bundles :data="products.bundles" :extra="loyaltyExtra" @buy="buy" />
                <DynamicPo v-for="(p, i) in poList" :key="i" :ref="p.type" :data="p" :extra="loyaltyExtra" @buy="buy" />
                <div class="title t-c v-m" v-if="products.coins.length > 0">
                    <img class="arrow reverse v-m" :src="_global.assetsRoot + '/pic_title.png'" />
                    <img class="title-icon v-m" :src="_global.assetsRoot + `/coins_${_i18n.locale}.png`" />
                    <img class="arrow v-m" :src="_global.assetsRoot + '/pic_title.png'" />
                </div>
                <coins :data="products.coins" :extra="loyaltyExtra" @buy="buy" />
                <div class="title t-c v-m" v-if="products.chips.length > 0">
                    <img class="arrow reverse v-m" :src="_global.assetsRoot + '/pic_title.png'" />
                    <img class="title-icon v-m" :src="_global.assetsRoot + `/dinero_${_i18n.locale}.png`" />
                    <img class="arrow v-m" :src="_global.assetsRoot + '/pic_title.png'" />
                </div>
                <chips :data="products.chips" :extra="loyaltyExtra" @buy="buy" />
                <div class="empty"></div>
            </div>
        </div>
        <div class="page-footer">
            <div class="user-info">
                <div class="user-id-cont">
                    <div class="user-id">
                        <img class="v-m btn" :src="_global.assetsRoot + '/tutorial_button.png'"
                            @click="showUserIDTutorialPopup" />
                        <span class="v-m fb fs-1-4 segpe userID">ID:{{ userID }}</span>
                    </div>
                    <div class="user-id-tip">
                        <span class="fs-1 segpe">{{ $t("message.userIDTip") }}</span>
                    </div>
                </div>
            </div>
            <div class="logout">
                <div class="btn logout-btn rel-center t-c v-m" @click.stop="showLogoutTip">
                    <img class="v-m" :src="_global.assetsRoot + '/logout_icon.png'" />
                    <span class="fs-1-5 fb v-m">{{ $t("message.logout") }}</span>
                </div>
            </div>
        </div>
        <Logout ref="logoutPopup" @logout="logout"></Logout>
        <Collect ref="collect" :data="purchase" :to="to" @collect="collect" @tanimation="showTextAnimation" />
        <Payment ref="payment" :paymentId="paymentId" @payment="openPaymentPage" @onhide="onPaymentHide" />
        <Award ref="award" :userID="userID" @airdrop-collected-coins="handleAirdropCoins"
            @open-redeem="showRedeemPopup" />
        <Redeem ref="redeem" />
        <FirstLogin ref="userIDTutorial" />
        <Scratch ref="scratchCard" :userID="userID" @bonus-collected="handleBonusCollection" />
        <Bonus ref="bonusModal" />
    </div>
</template>

<script>
import Logout from '../components/popup/Logout.vue';
import Collect from '../components/popup/Collect.vue';
import Payment from '../components/popup/Payment.vue';
import DynamicPo from '../components/popup/DynamicPo.vue';
import FirstLogin from '../components/popup/FirstLogin.vue';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import bundles from '../components/layouts/bundles.vue';
import coins from '../components/layouts/coins.vue';
import chips from '../components/layouts/chips.vue';
import api from '../network/api.js';
import utils from '../utils/utils.js';
import Award from '../components/popup/Award.vue';
import Scratch from '../components/popup/Scratch.vue';
import Redeem from '../components/popup/Redeem.vue';
import Bonus from '../components/popup/Bonus.vue';
export default {
    data() {
        return {
            loged: false,
            user: null,
            animationCoins: 0,
            animationChips: 0,
            swiperObj: null,
            swiperOptions: {
                loop: true,
                speed: 500,
                autoplay: {
                    delay: 3000,
                    stopOnLastSlide: false
                },
                on: {
                    click: function () {
                        window.vthis.wakeupApp && window.vthis.wakeupApp();
                    }
                }
            },
            isPending: false,
            products: {},
            loyalty: {},
            vip_store: {},
            paymentId: "",
            purchase: {},
            to: null,
            pendingTimer: null,
            singular: null,
            poList: [],
            poIndex: 0,
            airdrop: [],
            airdropCoins: null,
            bonusChips: null
        }
    },
    created() {
        if (this._global.user && this._global.products && this._global.loyalty && this._global.vip_store) {
            this.loged = true;
            this.user = this._global.user;
            this.products = this._global.products;
            this.loyalty = this._global.loyalty;
            this.vip_store = this._global.vip_store;
        }
        if (this._global.airdrop) {
            this.airdrop = this._global.airdrop;
        }
        window.vthis = this;
        this.swiperOptions.loop = this.products.banners && this.products.banners.length > 1;
        this.poList = this._global.poList || [];
    },
    mounted() {
        if (this.loged) {
            // To check purchase popup
            /*let purchase = {
                "isFree": true,
                "type": "",
                "coins": 500,
                "chips": 200,
                "wheel": "abc"
            }

            this.purchase = purchase;
            this.$refs.collect.show();*/

            if (this.$refs.swiperObj) {
                this.swiperObj = this.$refs.swiperObj.swiper;
                if (!this.products.banners || this.products.banners.length <= 1) this.swiperObj.autoplay.stop();
            }

            let coinsIcon = this.$refs.coinsIcon.getBoundingClientRect(),
                chipsIcon = this.$refs.chipsIcon.getBoundingClientRect();
            this.to = {
                coins: {
                    x: coinsIcon.left + (coinsIcon.width / 2),
                    y: coinsIcon.top + (coinsIcon.height / 2)
                },
                chips: {
                    x: chipsIcon.left + (chipsIcon.width / 2),
                    y: chipsIcon.top + (chipsIcon.height / 2)
                }
            }

            if (typeof singularSdk !== "undefined" && typeof SingularConfig !== "undefined") {
                this.singular = new SingularConfig("gamesmart_4611daf8", "2ff18b562cb48740fd92fe3419ab46ac", "com.gamesmartltd.doctorbingo").withCustomUserId(this.userID);
                singularSdk.init(this.singular);
            }

            this.pending(true);

            if(this._global.extra.bonus_id){
                if (['expired', 'not_available', 'not_found'].includes(this._global.extra.bonus_status)) {
                    this.$refs.bonusModal.show();
                }
                else{
                    this.$refs.scratchCard.show();
                }
            }
            else if (this.airdrop.length !== 0) {
                this.$refs.award.show();
            }
        }
    },
    computed: {
        userID() { return (this.user && this.user.userID) || null },
        avatar() { return (this.user && this.user.avatar) || (this._global.assetsRoot + '/avatar.png') },
        username() { return (this.user && this.user.username) || this.userID },
        coins() { return utils.fc(this.animationCoins || (this.user && this.user.coins)) || 0 },
        chips() { return utils.fc(this.animationChips || (this.user && this.user.chips)) || 0 },
        loyaltyExtra() {
            return {
                coins: this.vip_store.vip_level ? Number(this.vip_store.privileges[this.vip_store.vip_level].purchase_coins_x) : 0,
                chips: this.vip_store.vip_level ? Number(this.vip_store.privileges[this.vip_store.vip_level].purchase_chips_x) : 0
            }
        }
    },
    methods: {
        showLogoutTip() {
            this.$refs.logoutPopup.show()
        },
        logout() {
            this.$emit("logout")
        },
        wakeupApp() {
            utils.wakeupApp();
        },
        buy(data) {
            if (!this.userID) return;
            // 购买之前更新用户数据
            api.guestLogin(this._global.sid, this.userID).then((loginResp) => {
                if (loginResp.data.status === "ok") {
                    let user = loginResp.data;
                    // 处理用户数据
                    this._global.user = {
                        userID: user.user_id,
                        coins: user.coins,
                        chips: user.chips,
                        username: user.name,
                        lang: user.lang,
                        avatar: user.pic
                    };
                    localStorage.setItem("userinfo", JSON.stringify(this._global.user));
                    //this._i18n.locale = /(en)|(es)|(pt)/.test(data.lang) ? data.lang : 'en';
                    this.user = this._global.user;

                    if (data.free) {
                        api.saveFreePurchase(this.userID, data.hash).then((resp) => {
                            if (resp.data.status === "ok") {
                                let data = resp.data;
                                let purchase = {
                                    "isFree": true,
                                    "type": data.type,
                                    "coins": Number((data.coins || this.user.coins) - this.user.coins),
                                    "chips": Number((data.chips || this.user.chips) - this.user.chips),
                                    "wheel": typeof data.wheel !== 'undefined',
                                    "blackWheel": typeof data.wheel !== 'undefined' && data.wheel.black_wedge_index && data.wheel.black_wedge_index.length > 0
                                }

                                this.purchase = purchase;
                                this.$refs.collect.show();

                                if (purchase.type === "web_rolling_po") {
                                    let po = this.$refs[purchase.type];
                                    po && po[0] && po[0].unlock && po[0].unlock();
                                }
                            }
                        })
                    } else {
                        api.getProductHash(this.userID, data.hash).then((resp) => {
                            if (resp.data.id) {
                                this.paymentId = resp.data.id;

                                this.$refs.payment.show();
                            }
                        })
                    }
                } else console.error('update user data failed!')
            })
        },
        openPaymentPage() {
            this.$refs.payment.hide();
            if (!this.isPending) {
                this.isPending = true;
                this.pending();
            }
        },
        onPaymentHide() {
            this.poList && this.poList.map((po) => {
                po && po.type && this.$refs[po.type] && this.$refs[po.type][0] && this.$refs[po.type][0].resetButton && this.$refs[po.type][0].resetButton();
            })
        },
        showUserIDTutorialPopup() {
            let popup = this.$refs["userIDTutorial"];
            //console.log(this.$refs["userIDTutorial"])
            popup && popup.show();
        },
        pending(isOnce = false) {
            api.getPendingPurchase(this.userID).then((resp) => {
                if (resp.data.status === "ok" && resp.data.purchase_pending.length > 0) {
                    this.isPending = false;
                    this.onPendingResult(resp);
                } else {
                    !isOnce && (this.pendingTimer = setTimeout(this.pending.bind(this), 3000));
                }
            })
        },
        onPendingResult(resp) {
            let purchase = {
                "pendingId": resp.data.purchase_pending[0].pending_id,
                "type": resp.data.purchase_pending[0].type
            };
            resp.data.purchase_pending[0].reward_items.map((i) => {
                if (i.type === "coins") purchase["coins"] = Number(i.data)
                else if (i.type === "chips") purchase["chips"] = Number(i.data)
                else if (i.type === "loyalty") this.loyalty.loyalty_level = Number(i.data.loyalty_level)
                else if (i.type === "wheel_purchased") {
                    let product = i.data.products[0], wheel = product["items"].filter((i) => i.type === "wheel");
                    if (wheel && wheel.length > 0) {
                        wheel = wheel[0];
                        if (wheel["black_wedge_index"] && wheel["black_wedge_index"].length > 0) purchase["blackwheel"] = true;
                        else purchase["wheel"] = true;
                    }
                }
            })

            this.purchase = purchase;
            this.$refs.collect.show();
            this.pendingTimer && clearTimeout(this.pendingTimer);

            if (purchase.type === "web_rolling_po") {
                let po = this.$refs[purchase.type];
                po && po[0] && po[0].unlock && po[0].unlock();
            }
        },
        collect(data) {
            api.collectPending(this.userID, data.pendingId).then((resp) => {
                if (resp.data.status === "ok") {
                    // singular
                    this.singular && singularSdk.revenue("onShopPurchaseComplete", resp.data.isoCurrencyCode, Number(resp.data.localizedPrice));

                    this.loyalty.loyalty_level = Number(resp.data.loyalty_level);

                    let items = resp.data.reward_items;
                    this.showTextAnimation({ "items": items });

                    this.$refs.collect.showBonusAnimation();
                }
            })
        },
        showRedeemPopup() {
            this.$refs.redeem.show();
        },
        handleAirdropCoins(coinsValue) {
            // console.log(coinsValue.data)
            const formattedCoins = utils.fc(coinsValue.data.coins);
            this.airdropCoins = formattedCoins;
        },
        handleBonusCollection(resp) {
            if(this._global.extra.bonus_type === 'manual'){
                const formattedCoins = utils.fc(resp.data.coins);
                this.airdropCoins = formattedCoins;
            }
            else if(this._global.extra.bonus_type === 'chips'){
                const formattedChips = utils.fc(resp.data.chips);
                this.bonusChips = formattedChips;
            }
        },
        showTextAnimation(data) {
            let items = data.items, user = JSON.parse(JSON.stringify(this.user));
            items.map((i) => {
                if (i.type === "coins") {
                    user && user.coins && (user.coins = Number(user.coins) + Number(i.data));

                    // coins text animation
                    utils.animation(3000, this.user.coins, user.coins, (_cur) => {
                        this.animationCoins = Math.round(_cur);
                    }, () => {
                        this.animationCoins = 0
                    })
                } else if (i.type === "chips") {
                    user && user.chips && (user.chips = Number(user.chips) + Number(i.data));

                    // chips text animation
                    utils.animation(3000, this.user.chips, user.chips, (_cur) => {
                        this.animationChips = Math.round(_cur);
                    }, () => {
                        this.animationChips = 0
                    })
                }
            })
            this.user = user;
            localStorage.setItem("userinfo", JSON.stringify(this.user));
        }
    },
    components: {
        Bonus,
        Logout,
        swiper,
        swiperSlide,
        bundles,
        coins,
        chips,
        Collect,
        Payment,
        Award,
        Redeem,
        Scratch,
        DynamicPo,
        FirstLogin
    }
}
</script>

<style lang="scss">
@import "../assets/css/swiper.min.css";
@import "../assets/css/variables.scss";

#products-page {
    display: flex;
    flex-direction: column;
    height: 100%;
    background: url($assetRoot + "/list_bg.jpg") center no-repeat;
    background-size: 100% 100%;
    overflow: hidden;

    .page-header {
        display: flex;
        flex-direction: row;
        flex-basis: 4rem;
        background: url($assetRoot + "/top_balance_bg.png") left repeat-x;
        background-size: auto 100%;
        width: 90%;
        padding: 0 5%;

        div {
            line-height: 3.6rem;
        }

        .user-coins,
        .user-dinero {
            flex: 1;
            position: relative;
        }

        .coins,
        .dineros {
            position: absolute;
            display: inline-block;
            width: 8.7rem;
            height: 3rem;
            line-height: 2.8rem;
            padding: 0 0 0 2.4rem;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            -webkit-transform: translate(-50%, -50%);

            img {
                position: absolute;
                top: 50%;
                left: 1rem;
                width: auto;
                height: 2.5rem;
            }

            .coins-icon {
                transform: translate(-50%, -50%);
                -webkit-transform: translate(-50%, -50%);
            }

            .dinero-icon {
                transform: translate(-66.6%, -50%);
                -webkit-transform: translate(-66.6%, -50%);
            }

            span {
                display: inline-block;
                color: #FFF;
            }
        }

        .coins {
            background: url($assetRoot + "/balance_bg.png") right no-repeat;
            background-size: auto 100%;
        }

        .dineros {
            background: url($assetRoot + "/balance_bg.png") right no-repeat;
            background-size: auto 100%;
        }

        .user-info {
            flex-basis: 29rem;
            position: relative;

            img {
                width: 2.6rem;
                margin-left: 1rem;
                border-radius: 2rem;
            }

            .username {
                width: 5rem;
                display: inline-block;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                color: #FFF;
            }

            .user-id-cont {
                position: absolute;
                left: 10rem;
                top: .3rem;
                width: 17rem;
                display: inline-block;
                line-height: 0 !important;

                div {
                    display: inline-block;
                    line-height: 0 !important;
                }

                .user-id {
                    height: 1.8rem;

                    .userID {
                        padding: 0.2rem 1rem;
                        background: url($assetRoot + "/web_id_bg.png") center no-repeat;
                        background-size: 100% 100%;
                        line-height: 1.4rem !important;
                        color: #FFF;
                    }

                    .btn {
                        width: 1.8rem;
                    }
                }

                .user-id-tip {
                    color: #FFF;

                    span {
                        display: inline-block;
                        max-width: 100%;
                        line-height: 14px !important;
                        color: #FFDB32;
                        font-weight: bold;
                    }
                }
            }
        }

        .logout {
            flex-basis: 9rem;

            .logout-btn {
                display: inline-block;
                width: 7rem;
                height: 2.1rem;
                line-height: 1.9rem;
                background: url($assetRoot + "/logout_icon_bg.png") left repeat-x;
                background-size: 100% 100%;
                box-sizing: border-box;
                padding-bottom: .1rem;

                img {
                    width: 1rem;
                    margin-right: .2rem;
                }

                span {
                    display: inline-block;
                    height: 100%;
                    color: #FFF;
                }
            }
        }
    }

    .page-content {
        flex: 1;
        overflow-y: auto;

        .content {
            width: 1024px;
            margin: 0 auto;

            .banners {
                width: 100%;
                height: 100%;
                color: #FFF;

                img {
                    width: 100%;
                    height: 100%;
                }
            }

            .title {
                margin: .6rem 0;

                .title-icon {
                    transform: translate(0, .1rem);
                    -webkit-transform: translate(0, .1rem);
                }

                img {
                    height: 2rem;
                }

                .promition {
                    height: 2.6rem;
                }

                .arrow {
                    height: 1.5rem;
                }
            }

            .coins,
            .chips,
            .bundles {
                text-align: center;
            }

            .coins .coin,
            .chips .chip {
                display: inline-block;
                width: 320px;
                height: 260px;
                margin-top: 1rem;
                background-size: 100% 100%;
                position: relative;

                .permissions {

                    .loyalty {

                        .icon-loyalty {
                            width: 3rem;
                            height: auto;
                            transform: translate(-10%, -.4rem);
                            -webkit-transform: translate(-10%, -.4rem);
                        }

                        .loyalty-points {
                            display: inline-block;
                            color: #FFF;
                            transform: translate(-1.2rem, .5rem);
                            -webkit-transform: translate(-1.2rem, .5rem);
                            text-shadow: 0 2px #FF0037, 0 -2px #FF0037, -2px 0 #FF0037, 2px 0 #FF0037,
                                2px 2px #FF0037, 2px -2px #FF0037, -2px 2px #FF0037, -2px -2px #FF0037;
                        }
                    }
                }

                .rewards {

                    .coin-icon,
                    .chip-icon {
                        width: 300px;
                        padding-bottom: 40px;

                        img {
                            width: inherit;
                        }
                    }
                }

                .reward-inf {
                    position: absolute;
                    left: 0;
                    bottom: 0;
                    width: 100%;

                    .coin-count,
                    .chip-count {

                        span {
                            text-shadow: 0 2px #271807, 0 -2px #271807, -2px 0 #271807, 2px 0 #271807,
                                2px 2px #271807, 2px -2px #271807, -2px 2px #271807, -2px -2px #271807;
                        }
                    }

                    .coin-count span {
                        color: #F5F678;
                    }

                    .chip-count span {
                        color: #00FF06;
                    }

                    .price {
                        margin: 1rem 0 -2px 0;

                        .price-btn {
                            width: 196px;
                            height: 68px;
                            line-height: 68px;
                            margin: 0 auto;
                            background: url($assetRoot + "/price_btn.png") center no-repeat;
                            background-size: 100% 100%;

                            span {
                                color: #FFF;
                                text-shadow: 0 2px #271807, 0 -2px #271807, -2px 0 #271807, 2px 0 #271807,
                                    2px 2px #271807, 2px -2px #271807, -2px 2px #271807, -2px -2px #271807;
                                letter-spacing: 1px;
                            }
                        }
                    }
                }
            }

            .coin:not(:nth-child(3n+1)),
            .chip:not(:nth-child(3n+1)) {
                margin-left: 30px;
            }

            .coin:nth-child(n+4),
            .chip:nth-child(n+4) {
                margin-top: 2.5rem;
            }

            .empty {
                height: 2.5rem;
            }
        }
    }

    .page-footer {
        flex-basis: 5rem;
        display: none;
        background-color: #E5F1FF;
        flex-direction: row;

        .user-info {
            flex: 2;
            line-height: 5rem;
        }

        .logout {
            flex-basis: 13rem;

            .logout-btn {
                display: inline-block;
                width: 12rem;
                height: 4rem;
                line-height: 3.6rem;
                background: url($assetRoot + "/logout_icon_bg.png") left repeat-x;
                background-size: 100% 100%;
                box-sizing: border-box;
                padding-bottom: .4rem;

                img {
                    width: 1.8rem;
                    margin-right: .5rem;
                }

                span {
                    display: inline-block;
                    height: 100%;
                    color: #FFF;
                }
            }
        }
    }
}

.mobile {

    #products-page {
        background: url($assetRoot + "/list_bg_m.jpg") center no-repeat;
        background-size: 100% 100%;

        .page-header {
            flex-basis: 5rem;

            div {
                line-height: 5rem;
            }

            .user-info {
                flex-basis: 12rem;
            }

            .user-info .user-id-cont,
            .logout {
                display: none;
            }

            .coins {
                width: 10.5rem;
                padding: 0 0 0 2.2rem;
            }

            .chips {
                width: 10rem;
                padding: 0 0 0 2.6rem;
            }

            .coins,
            .dineros {
                height: 3.6rem;
                line-height: 3.4rem;

                img {
                    height: 3.2rem;
                    left: .6rem;
                }

                span {
                    transform-origin: 0 50%;
                    font-size: 1.2rem;
                }
            }
        }

        .page-content {

            .content {
                width: 100%;

                .title {

                    img {
                        height: 3rem;
                    }

                    .promition {
                        height: 3.5rem;
                    }
                }

                .banners {
                    height: 28.32vw;
                }

                .bundles {

                    .bundle {
                        height: 44vw;

                        .bundle-content {
                            padding: 0 7vw;

                            .permissions {
                                flex-basis: 16.7vw;

                                .loyalty {
                                    margin: 11vw 0 0 auto;
                                }

                                .extra {
                                    margin: 10vw 0 0 auto;
                                }
                            }

                            .rewards {

                                .reward-items {
                                    margin-top: 9vw;
                                    height: 26.4vw;

                                    .reward-item {
                                        width: calc(100% - 13vw);
                                        height: 7.3vw;
                                        line-height: 7.3vw;
                                        margin: 0 0 0 auto;
                                    }
                                }

                                .buy-now {
                                    height: 8vw;

                                    .buy-btn {
                                        width: 29vw;
                                        margin: 0 0 0 -15.6vw;
                                    }
                                }
                            }
                        }
                    }
                }

                .coins,
                .chips {
                    width: 100%;
                    margin: 0 auto;
                }

                .coins .coin,
                .chips .chip {
                    width: 45vw;
                    height: 36.5vw;

                    .permissions {

                        .loyalty {

                            .icon-loyalty {
                                width: 8vw;
                                transform: translate(-10%, -1vw);
                                -webkit-transform: translate(-10%, -1vw);
                            }

                            .loyalty-points {
                                font-size: 2rem;
                                transform: translate(-4vw, 2vw);
                                -webkit-transform: translate(-4vw, 2vw);
                                text-shadow: 0 1px #FF0037, 0 -1px #FF0037, -1px 0 #FF0037, 1px 0 #FF0037,
                                    1px 1px #FF0037, 1px -1px #FF0037, -1px 1px #FF0037, -1px -1px #FF0037;
                            }
                        }
                    }

                    .rewards {
                        margin: 0;

                        .reward-icon {
                            width: 100%;
                            padding: 0;

                            img {
                                width: 45vw;
                                transform: translate(0, -1rem);
                                -webkit-transform: translate(0, -1rem);
                            }
                        }
                    }

                    .reward-inf {

                        .reward-count {

                            span {
                                font-size: 2.6rem;
                                text-shadow: 0 1px #271807, 0 -1px #271807, -1px 0 #271807, 1px 0 #271807,
                                    1px 1px #271807, 1px -1px #271807, -1px 1px #271807, -1px -1px #271807;
                            }
                        }
                    }

                    .price {
                        margin: 2rem 0 0 0;

                        .price-btn {
                            width: 25vw;
                            height: 9vw;
                            line-height: 9vw;
                            margin-bottom: -3px;

                            span {
                                font-size: 2.4rem;
                                text-shadow: 0 1px #271807, 0 -1px #271807, -1px 0 #271807, 1px 0 #271807,
                                    1px 1px #271807, 1px -1px #271807, -1px 1px #271807, -1px -1px #271807;
                            }
                        }
                    }
                }

                .coin:nth-child(even),
                .chip:nth-child(even) {
                    margin-left: 3vw;
                }

                .coin:nth-child(odd),
                .chip:nth-child(odd) {
                    margin-left: 0;
                }
            }
        }
    }

    .page-footer {
        display: flex !important;

        .user-info {
            position: relative;

            .btn {
                width: 4rem;
                margin: 0 1rem;
            }

            .user-id-cont {
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                height: 100%;

                div {
                    line-height: 0 !important;
                }

                .user-id {
                    height: 3rem;
                    padding: .5rem 0 0 0;

                    .userID {
                        padding: 0.4rem 1.5rem;
                        background: url($assetRoot + "/id_bg.png") center no-repeat;
                        background-size: 100% 100%;
                        line-height: 1.8rem !important;
                        color: #FFF;
                    }

                    .btn {
                        width: 3rem;
                    }
                }

                .user-id-tip {
                    color: #4064DF;

                    span {
                        display: inline-block;
                        max-width: 100%;
                        line-height: 1rem !important;
                    }
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/ProductList.vue